import { motion } from 'framer-motion'

const FeatureVideo = ({ videoSrc, label = 'app.doctorlegal.com.br' }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
      className="relative w-full max-w-[680px] mx-auto"
    >
      <div
        className="rounded-2xl p-3"
        style={{
          background: '#F0F2F5',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.06)',
        }}
      >
        <div
          className="rounded-xl overflow-hidden bg-white"
          style={{ boxShadow: '0 1px 4px rgba(0, 0, 0, 0.04)' }}
        >
          <div className="flex items-center gap-2 px-4 py-3 bg-[#F7F7F8] border-b border-black/5">
            <div className="flex items-center gap-1.5">
              <div className="w-[10px] h-[10px] rounded-full bg-[#FF5F57]" />
              <div className="w-[10px] h-[10px] rounded-full bg-[#FFBD2E]" />
              <div className="w-[10px] h-[10px] rounded-full bg-[#28C840]" />
            </div>

            <div className="flex-1 ml-3">
              <div
                className="flex items-center gap-2 px-3 py-1.5 rounded-md text-xs"
                style={{ background: 'rgba(0,0,0,0.04)' }}
              >
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#9CA3AF"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
                <span
                  style={{
                    color: '#9CA3AF',
                    fontSize: '11px',
                    fontFamily: 'Inter, system-ui, sans-serif',
                  }}
                >
                  {label}
                </span>
              </div>
            </div>
          </div>

          <div className="relative">
            <video
              aria-label="Demonstração do recurso da plataforma"
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-auto block"
            >
              <source src={videoSrc} type="video/mp4" />
            </video>
          </div>
        </div>
      </div>

      <div
        className="absolute -inset-6 -z-10 rounded-3xl opacity-[0.07] blur-[40px]"
        style={{
          background: 'radial-gradient(circle, #007AFF 0%, transparent 70%)',
        }}
      />
    </motion.div>
  )
}

export default FeatureVideo
